/* eslint-disable prefer-destructuring */
import { expiredToken } from '@config';
import { setLogin } from '@helper_auth';
import { useRouter } from 'next/router';
import { getApiHost } from '@helpers/config';
import Layout from '@layout';
import cookies from 'js-cookie';
// import { encrypt } from '@root/core/helpers/encryption';

const Core = (props) => {
    const { Content, storeLogo } = props;
    const router = useRouter();
    const pageConfig = {
        header: false,
        sidebar: false,
    };

    const [email, setEmail] = React.useState('');
    const [password, setPassword] = React.useState('');

    const signInMethod = async () => {
        try {
            const myHeaders = new Headers();
            myHeaders.append('Content-Type', 'application/json');
            myHeaders.append('Cookie', 'next-i18next=en');

            const raw = JSON.stringify({
                url_endpoint: `${getApiHost()}/generate-user-token`,
                method: 'post',
                data: {
                    email,
                    password,
                },
            });

            const res = await fetch('/internal-rest', {
                method: 'POST',
                headers: myHeaders,
                body: raw,
            });
            const resJson = await res.json();
            const resJsonStatus = await res.status;

            if (resJson && resJsonStatus === 200 && resJson[0].status !== 400) {
                setLogin(1, expiredToken);
                router.push('/');
                cookies.set('user_id', resJson[0].user_id);
                cookies.set('role_id', resJson[0].role_id);
                cookies.set('vendor_id', resJson[0].vendor_id === 'NULL' ? null : resJson[0].vendor_id);
                cookies.set('role_name', resJson[0].role_name);
                cookies.set('category_product', resJson[0].category_product);
                cookies.set('download_id', resJson[0].token);
                cookies.set('multi_category', resJson[0]?.category_product_gm_md || '');
                window.toastMessage({
                    open: true,
                    variant: 'success',
                    text: 'Berhasil Login',
                });
            } else {
                window.toastMessage({
                    open: true,
                    variant: 'error',
                    text: resJson[0]?.message || 'Login Gagal',
                });
            }
        } catch (error) {
            window.toastMessage({
                open: true,
                variant: 'error',
                text: 'Login Gagal',
            });
        }
    };
    const contentProps = {
        email,
        setEmail,
        password,
        setPassword,
        signInMethod,
        storeLogo,
    };

    return (
        <Layout pageConfig={pageConfig}>
            <Content {...contentProps} />
        </Layout>
    );
};

export default Core;
